import { useTranslation } from 'react-i18next';

// Components
import IconButton from '../../atoms/IconButton/IconButton';
import useToast from '../../molecules/Toast/useToast';

/**
 * Copies a personal view keyword to the clipboard
 * @param {object} params
 * @param {string} params.keyword - Keyword of the personal view
 * @returns {React.ReactNode}
 */
function PersonalViewCopyKeywordButton({ keyword }) {
  const { t } = useTranslation();
  const { notify } = useToast();

  /**
   * @param {React.MouseEvent<HTMLButtonElement>} e
   */
  const handleClick = (e) => {
    e.stopPropagation();
    navigator.clipboard.writeText(keyword)
      .then(() => notify({ message: t('personalViews.keywordCopied') }))
      .catch(() => notify({ message: t('personalViews.keywordCopyError'), type: 'alert' }));
  };

  return (
    <IconButton
      title={t('personalViews.copyKeyword')}
      icon="copy"
      color="transparent"
      size="medium"
      onClick={handleClick}
    />
  );
}

export default PersonalViewCopyKeywordButton;
